'use client'

import React from 'react'

import { LoadingBar } from '@/components/ui/loading-bar'
import { Logo } from '@/components/ui/logo'

export const Loading = () => {
  return (
    <div className="flex w-full max-w-xs flex-col items-center gap-10">
      <Logo className="h-10" />
      <LoadingBar />
    </div>
  )
}
